/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { FormTransformations } from "../../../types/ProductService/ProductService";
import abstractAdministrativeLitigationCaseTransformations from "./abstractAdministrativeLitigationCaseTransformations";

const civilServiceLawTransformations: FormTransformations = {
  dateFields: [
    ...abstractAdministrativeLitigationCaseTransformations.dateFields!,
    { path: "client.birthDate", type: "date" },
  ],
  numberFields: abstractAdministrativeLitigationCaseTransformations.numberFields,
  timeFields: [...abstractAdministrativeLitigationCaseTransformations.timeFields!],
  floatFields: [...abstractAdministrativeLitigationCaseTransformations.floatFields!],
  ibanFields: abstractAdministrativeLitigationCaseTransformations.ibanFields,
};

export default civilServiceLawTransformations;
